import { useMemo } from 'react';
import { useGetRepairSegmentsQuery } from 'src/api/rtk/base/slices/objectTypes/repairPlanApiSlice';

export function useMinMaxRating({ filter, enabled = false }: { filter?: string, enabled?: boolean }) {
  const { data: minRes, isFetching: fMin } = useGetRepairSegmentsQuery({
    $orderby: 'Rating asc', $top: 1, $filter: filter
  }, { skip: !enabled });

  const { data: maxRes, isFetching: fMax } = useGetRepairSegmentsQuery({
    $orderby: 'Rating desc', $top: 1, $filter: filter
  }, { skip: !enabled });

  const min = useMemo(() => minRes?.value?.[0]?.Rating, [minRes]);
  const max = useMemo(() => maxRes?.value?.[0]?.Rating, [maxRes]);
  const isLoading = enabled && (fMin || fMax);

  return { min, max, isLoading };
}